import PropTypes from 'prop-types';
import React from 'react';

// Ensure React is globally available for third-party components (Tagify)
window.React = React;

import Popup from "reactjs-popup";
import Tags from "@yaireo/tagify/dist/react.tagify";
import "../styles/setlistPopups.css";

const sharePopupContentStyle = {
  border: "none",
  borderRadius: "12px",
  boxShadow: "0 8px 8px -4px rgba(10,13,18,0.03), 0 20px 24px -4px rgba(10,13,18,0.08)",
  width: "min(560px, calc(100vw - 32px))",
  maxHeight: "calc(100vh - 48px)",
  overflowY: "auto",
  padding: "24px",
  background: "var(--sl-bg-primary)",
};

const canSubmitForm = (emailsToInvite) => {
  return (
    emailsToInvite
      && emailsToInvite.length > 0
  );
}

const ShareSettingsPopup = ({
  csrfToken,
  team,
  confirm,
  currentUser,
  confirmInvitation,
  confirmInvitationChanged,
  confirmInvitationMemoChanged,
  emailsToInvite,
  emailsToInviteChanged,
  calendarEventContacts,
  guestRole,
  createConfirmInvitations,
  confirmInvitationsAndTeamMemberships,
  isViewingGuests,
  isViewingGuestsChanged,
  deleteConfirmInvitation,
  removeConfirmAccess,
  shareSettingsPopupClosed
}) => (
  <div>
    <Popup
      open={Object.keys(confirmInvitation).length > 0}
      contentStyle={sharePopupContentStyle}
      closeOnDocumentClick={false}
      className={""}
      onClose={() => {
          shareSettingsPopupClosed();
          confirmInvitationChanged({});
        }
      }
    >
      <div className="sl-popup">
        <div className="sl-popup-header">
          {isViewingGuests ? (
            <button
              className="sl-popup-back"
              onClick={() => isViewingGuestsChanged(false)}
            >
              ← Back
            </button>
          ) : (
            <h3 className="sl-popup-title">Share this page</h3>
          )}
          <button
            className="sl-popup-close"
            onClick={() => confirmInvitationChanged({})}
          >
            ×
          </button>
        </div>

        {isViewingGuests ? (
          <div>
            <strong style={{ fontSize: "16px", display: "block", marginBottom: "4px" }}>
              People with access to this event page...
            </strong>
            <div style={{ overflowX: "auto" }}>
              <table className="sl-popup-guest-table">
                <colgroup>
                  <col span={1} style={{ width: "80%" }} />
                  <col span={1} style={{ width: "20%" }} />
                </colgroup>
                <tbody>
                  {confirmInvitationsAndTeamMemberships.map((entry, index) => (
                    <tr key={index}>
                      <td title={entry.name_with_email} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {entry.name_with_email}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <button
                          className="sl-popup-guest-remove"
                          onClick={(e) => {
                            e.preventDefault();

                            if (!window.confirm("Are you sure?")) {
                              return false;
                            }

                            if (entry.type_for_ui === "Invitations::Confirm") {
                              deleteConfirmInvitation(csrfToken, team, entry, confirmInvitationsAndTeamMemberships);
                            } else {
                              removeConfirmAccess(csrfToken, team, entry, confirm, confirmInvitationsAndTeamMemberships);
                            }
                          }}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div>
            <p className="sl-popup-subtext">
              Share a read-only version of this page with agents and others. Share members will be able to upload assets.
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();

                if (!canSubmitForm(emailsToInvite)) {
                  return false;
                }

                createConfirmInvitations(csrfToken, team, confirm, confirmInvitation, emailsToInvite, guestRole);
              }}
            >
              <div className="sl-popup-field">
                <Tags
                  placeholder={"Add an email or contact"}
                  settings={{
                    pattern: /[^@\s]+@[^@\s]+/,
                    tagTextProp: "name",
                    dropdown: {
                      searchKeys: ["name", "value"]
                    },
                    blacklist: confirmInvitationsAndTeamMemberships.map((d) => d.email.toLowerCase()),
                    whitelist: calendarEventContacts
                                 .filter((cec) => cec.id)
                                 .filter((cec) => cec.contact.email && cec.contact.email.length > 0)
                                 .filter((cec) => !confirmInvitationsAndTeamMemberships.map((d) => d.email.toLowerCase()).includes(cec.contact.email.toLowerCase()))
                                 .map((cec) => {
                                   return Object.assign({}, cec.contact, {
                                     value: cec.contact.email
                                   });
                                 }),
                    templates: {
                      dropdownItem: function(item){
                        return `<div ${this.getAttributes(item)}
                          class='${this.settings.classNames.dropdownItem} ${item.class ? item.class : ""}'
                          tabindex="0"
                          role="option">${item.name} - ${item.value}</div>`
                      }
                    }
                  }}
                  defaultValue={emailsToInvite}
                  onChange={(e) => {
                    emailsToInviteChanged(e.detail.tagify.value);
                  }}
                />
              </div>
              {emailsToInvite.length > 0 ? (
                <div className="sl-popup-field">
                  <textarea
                    className="sl-popup-textarea"
                    placeholder={"Add a note"}
                    value={confirmInvitation.memo || ""}
                    onChange={(e) => {
                      confirmInvitationMemoChanged(e.target.value);
                    }}
                    rows="3"
                  />
                </div>
              ) : null}
              <div className="sl-popup-footer">
                <div style={{ flex: 1, display: "flex", alignItems: "flex-end" }}>
                  {confirmInvitationsAndTeamMemberships.length === 0 ? (
                    <span style={{ fontSize: "14px", color: "var(--sl-text-tertiary)" }}>
                      0 people have access
                    </span>
                  ) : (
                    <button
                      className="sl-popup-access-count"
                      onClick={(e) => {
                        e.preventDefault();
                        isViewingGuestsChanged(true);
                      }}
                    >
                      {confirmInvitationsAndTeamMemberships.length === 1 ? (
                        <span>1 person has access</span>
                      ) : (
                        <span>{confirmInvitationsAndTeamMemberships.length} people have access</span>
                      )}
                    </button>
                  )}
                </div>
                <button
                  type="submit"
                  className="btn-setlist-primary"
                  disabled={!canSubmitForm(emailsToInvite)}
                >
                  Share
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </Popup>
  </div>
);

ShareSettingsPopup.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirmInvitation: PropTypes.object,
  confirmInvitationChanged: PropTypes.func.isRequired,
  confirmInvitationMemoChanged: PropTypes.func.isRequired,
  emailsToInvite: PropTypes.array,
  emailsToInviteChanged: PropTypes.func.isRequired,
  calendarEventContacts: PropTypes.array,
  guestRole: PropTypes.object.isRequired,
  createConfirmInvitations: PropTypes.func.isRequired,
  confirmInvitationsAndTeamMemberships: PropTypes.array,
  isViewingGuests: PropTypes.bool,
  isViewingGuestsChanged: PropTypes.func.isRequired,
  deleteConfirmInvitation: PropTypes.func.isRequired,
  removeConfirmAccess: PropTypes.func.isRequired,
  shareSettingsPopupClosed: PropTypes.func.isRequired
};

export default ShareSettingsPopup;
